import React, { Component } from 'react';
import { connect } from 'react-redux';
import fillInBlankActions from '../../actions/fillInBlank';
import { FillInBlankForm } from '../../../Shared';

class NewFillInBlank extends Component {
  submitNewQuestion = (data, optimalResponse) => {
    const { dispatch } = this.props;
    dispatch(fillInBlankActions.submitNewQuestion(data, optimalResponse));
  };

  render() {
    return <FillInBlankForm action={this.submitNewQuestion} new={true} />;
  }
}

function select(state) {
  return {};
}

export default connect(select)(NewFillInBlank);
